import DescriptionList from './description-list';
import Description from './description';

DescriptionList.Description = Description;
export default DescriptionList;
